//export const webUrl = process.env.NODE_ENV === 'development' ? '' : '';

export const apiUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:7655' : 'https://ss.api.suntomorrow.com';